var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_813_31782)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 14,
    r: 14,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_813_31782",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_813_31782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_813_31782",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_813_31782",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_813_31782",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAuxJREFUaEPtmT9oFEEUxr+duxCO5FT0jCAGzxRGERX/XIqA2CgoiIKFiIiNhZZCCotAQhAFi3RaWFgpoo2FWChaKYrkCEEFiSniiaYwRvGMIUou+2Qn7HJ3e3czszOHO5Itd3dmvt/Me2/em3Fg+eNYrh/LAP96BY2tgPszT5gdAebeAPOTQOkbsDi/xJdIAck1QKoLaNsBpHvAVuSMjK3difvxMuH7I2BhBg6o4YJQucW2ZIDVh8A29mtpiNzYLQwSvt4HqBSIFgFU03EgJwmsPQ6WHYqkRbmRO32X8GkYWPwlnHGRf1SsSKId6OwD6zippEnpZ3fyImHmQeQZlwLKHAXruiqtS/pH9/1ZcoovRBq0vgcrsrIXrPumlDapnzzxKL7UNhkRXYVJSUIIAcrNRtVJRYJF3ylzTGhODQG4wxaGmmbzQgAvSmUHGzp2Y4DRHHnRxn9UVqB3oDto5xLh1aUJkd7Qd25SiXawPfm6Out+8OK8M31PeVC/gTEAr8OOE3X3ifoA+e3k0EI8AJwkWO5tTa01X/L04MttrahjdAW8aVx3umbaURtgbB/J5DaNlsc4QEsGbNfzkN7QC55Vjp/h2lScthrGBEAod9pyK5TFhgGmrhOmrsUTYP15sA0XKjSHASbOEX48iyfAqv1gm28IAF4fJPz5HE+A1k6wnU8EAKO7ya+kYucDLAW2d0wAMLI1KKviBsADS8/4/w5gvQlZ78SGwuhcKV2xD7UlZyPnVX5DkgqjhjYybbU1OiCpjcxQKtEUAJlUwhvYNZDMmQCoPgiTSuY4gIF0+mnhCIbvfOAcfac24UD2oTJTBYBKOs0hNAuaw1e2ofh76dQu3ZrA4/530QFUCxoOoFlSGgWIUlJyCI2i3pgJRS3qOYDtxyocouw8VCe5U3YAANoHW/6gVh8tlkNYe7gbQNh8vB5A2HzBUe6I1l4xVUcTay/5QiC2XrNGie8m2whvaEwO1oy+lgGaMasqff4FhH+7QN5YuvoAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.57841d0bd82072c4eea1340ccc5b2fe7.svg";
export { ForwardRef as ReactComponent };